
import React from 'react';
import { IntegrationFlow, Language } from '../../types';
import { TRANSLATIONS } from '../../constants';

interface FlowsHeaderProps {
  language: Language;
  activeFlow: IntegrationFlow;
  isSimulating: boolean;
  onSetViewMode: (mode: 'list' | 'editor') => void;
  onUpdateFlowName: (name: string) => void;
  onAutoLayout: () => void;
  onToggleSimulation: () => void;
  onSave: () => void;
}

const FlowsHeader: React.FC<FlowsHeaderProps> = ({ 
  language, activeFlow, isSimulating, onSetViewMode, 
  onUpdateFlowName, onAutoLayout, onToggleSimulation, onSave 
}) => {
  const t = TRANSLATIONS[language];
  const isRtl = language === 'ar';

  return (
    <header className="h-16 border-b border-white/5 bg-[#15151a] flex items-center justify-between px-6 z-20 shrink-0 shadow-sm">
      <div className="flex items-center gap-4">
        <button onClick={() => onSetViewMode('list')} className="w-9 h-9 rounded-xl hover:bg-white/10 flex items-center justify-center text-slate-400 transition-colors">
          <i className={`fas fa-arrow-${isRtl ? 'right' : 'left'}`}></i>
        </button>
        <div className="h-6 w-px bg-white/10"></div>
        <div>
           <input 
             value={activeFlow.name} 
             onChange={(e) => onUpdateFlowName(e.target.value)}
             className="bg-transparent text-sm font-black text-white outline-none placeholder-slate-600 w-48"
           />
           <div className="flex items-center gap-2">
              <span className={`w-1.5 h-1.5 rounded-full ${activeFlow.active ? 'bg-emerald-500' : 'bg-amber-500'}`}></span>
              <span className="text-[10px] text-slate-500 font-mono uppercase">{activeFlow.active ? 'Active' : 'Draft'}</span>
           </div>
        </div>
      </div>

      <div className="flex items-center gap-3">
         <button onClick={onAutoLayout} className="hidden md:flex items-center gap-2 px-4 py-2 bg-white/5 hover:bg-white/10 text-slate-300 rounded-xl text-xs font-bold transition-all border border-white/5">
            <i className="fas fa-wand-magic-sparkles text-purple-400"></i><span>Auto Layout</span>
         </button>
         <button onClick={onToggleSimulation} className={`flex items-center gap-2 px-4 py-2 rounded-xl text-xs font-bold transition-all border ${isSimulating ? 'bg-emerald-500/20 border-emerald-500 text-emerald-400' : 'bg-white/5 border-white/5 text-slate-300 hover:text-white'}`}>
            <i className={`fas ${isSimulating ? 'fa-stop' : 'fa-play'}`}></i><span>{isSimulating ? 'Stop' : 'Test'}</span>
         </button>
         <button onClick={onSave} className="px-6 py-2 bg-emerald-500 hover:bg-emerald-600 text-white rounded-xl text-xs font-black transition-all shadow-lg shadow-emerald-500/20">{t.saveFlow}</button>
      </div>
    </header>
  );
};
export default FlowsHeader;
